import { useEffect } from 'react'
import { useLogout } from '@refinedev/core'

import axios from 'axios'

import { TG_USER_DATA, GOOGLE_TOKEN, VIEW_AS_INVESTOR, isAdmin, isGoogleTokenValid } from './auth-storage'

export const axiosInstance = axios.create()
axiosInstance.interceptors.request.use(request => {
	const tgUserData = localStorage.getItem(TG_USER_DATA)
	const googleToken = localStorage.getItem(GOOGLE_TOKEN)

	if (tgUserData) {
		request.headers['Telegram-Data'] = encodeURI(tgUserData)
	}
	if (googleToken) {
		request.headers['Authorization'] = `Bearer ${googleToken}`
	}

	// Admin impersonation: view the cabinet as the selected investor. The backend
	// only honors this header for admins, so it is safe to always attach.
	if (isAdmin()) {
		try {
			const viewAs = JSON.parse(localStorage.getItem(VIEW_AS_INVESTOR))
			if (viewAs?.id) request.headers['View-As-Investor-Id'] = viewAs.id
		} catch {
			// ignore malformed value
		}
	}

	return request
})

export const AxiosInterceptor = ({ children }) => {
	const { mutate: logout } = useLogout()

	useEffect(() => {
		const resInterceptor = response => {
			return response
		}

		const errInterceptor = error => {
			// Don't auto-logout an admin with a VALID Google session on a 401 —
			// e.g. before an investor is selected. But an expired/invalid Google
			// token, or a Telegram session, should log out on 401.
			if (error.response?.status === 401 && !isGoogleTokenValid()) {
				logout()
			}

			// return Promise.resolve(error.response)
			return Promise.reject(error)
		}
		const interceptor = axiosInstance.interceptors.response.use(resInterceptor, errInterceptor)
		return () => axiosInstance.interceptors.response.eject(interceptor)
	}, [logout])

	return children
}
